const getExtensionFromFileName = (fileName) => {
  const splittedName = fileName.split(".");
  if (splittedName.length === 1) {
    return null;
  }
  return splittedName.pop() ?? null;
};

export { getExtensionFromFileName };
//# sourceMappingURL=index.js.map
